/* eslint-disable react/display-name */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

export default class UseCase extends React.Component {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    href: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
  };

  renderLink = () => {
    const { href, children } = this.props;
    if (href.startsWith('/')) {
      return (
        <Link href={href}>
          {children}
        </Link>
      );
    }
    return <a href={href}>{children}</a>;
  };

  render() {
    return this.renderLink();
  }
}
